import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { hasGoogleSession } from "@/lib/google";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: if returning from Google, AuthCallback exchanges the session first.
    if (!hasGoogleSession()) api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onExpired = () => setUser(false);
    const onMustChange = () => setUser((u) => (u ? { ...u, must_change_password: true } : u));
    window.addEventListener("auth:expired", onExpired);
    window.addEventListener("auth:must-change", onMustChange);
    return () => { window.removeEventListener("auth:expired", onExpired); window.removeEventListener("auth:must-change", onMustChange); };
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, login, logout, isOwner: user?.role === "dueno" }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
